import type { SupportedLocale } from '@/i18n/config';
import type { ScheduledPageCopy } from './scheduled-page-copy';
import { scheduledDetailedCopyArabicRussian } from './scheduled-page-copy-translations-ar-ru';
import { scheduledDetailedCopyChinese } from './scheduled-page-copy-translations-chinese';
import { scheduledDetailedCopyJapaneseKorean } from './scheduled-page-copy-translations-east-asian';
import { scheduledDetailedCopyIndicSoutheastAsian } from './scheduled-page-copy-translations-indic-sea';
import { scheduledDetailedCopyPortuguese } from './scheduled-page-copy-translations-pt-br';
import {
  scheduledDetailedCopyFrenchItalian,
  scheduledDetailedCopyGermanSpanish,
} from './scheduled-page-copy-translations-western';

export type ScheduledDetailedCopy = Pick<
  ScheduledPageCopy,
  'status' | 'editor' | 'detail' | 'notifications' | 'errors'
>;

type NonEnglishLocale = Exclude<SupportedLocale, 'en'>;

export const scheduledDetailedCopy = {
  ...scheduledDetailedCopyArabicRussian,
  ...scheduledDetailedCopyGermanSpanish,
  ...scheduledDetailedCopyFrenchItalian,
  ...scheduledDetailedCopyPortuguese,
  ...scheduledDetailedCopyIndicSoutheastAsian,
  ...scheduledDetailedCopyJapaneseKorean,
  ...scheduledDetailedCopyChinese,
} satisfies Record<NonEnglishLocale, ScheduledDetailedCopy>;
